import repositories from '..';

const resource = '/integration/apis';

export default {
  getInitData: () => repositories.get(`${resource}/data/init`),
};
